export default __webpack_public_path__ + "static/media/benifits-big.aa89d03e.png";